document.addEventListener('DOMContentLoaded', () => {
  // Find all instances of the country selector on the page

  const dataScripts = document.querySelectorAll('[data-bga-country-selector-data]');

  if (dataScripts.length === 0) {
    return; // Exit if no selectors are found
  }

  dataScripts.forEach(script => {
    const blockId = script.getAttribute('data-bga-country-selector-data');
    const selectEl = document.getElementById(`BgaCountrySelector-${blockId}`);

    if (!selectEl) return;

    // Fetch and parse all data from Liquid
    let data;
    try {
      data = JSON.parse(script.textContent);
    } catch (e) {
      console.error('BGA Country Selector: Could not parse data JSON.', e);
      return;
    }

    const { stores, translations, currentLanguage, currentHost } = data;

    // Find the correct translation list, with English as fallback
    const langKey = translations[currentLanguage] ? currentLanguage : 'en';
    const currentTranslations = translations[langKey];
    const fallbackTranslations = translations['en'];

    // Build and add all <option> elements
    stores.forEach(store => {
      const option = document.createElement('option');
      option.value = store.url;
      option.textContent = currentTranslations[store.id] || fallbackTranslations[store.id];

      // Mark the current store as selected by comparing the list in footer.liquid to the current domain
      if (store.host === currentHost) {
        option.selected = true;
      }
      selectEl.appendChild(option);
    });

    // Add event listener for redirection
    const handleChange = (event) => {
      const url = event.target.value;
      if (url) {
        window.location.href = url;
      }
    };
    
    selectEl.addEventListener('change', handleChange);
  });
});